export const locale = {
    lang: 'ar',
    data: {
        ALL_CARDS: 'جميع البطاقات',
        LIST_CARDS: 'بطاقات من القوائم',
        TYPE: 'النوع',
        POINTS: 'نقاط',
        CATEGORIES: 'الألوان',
        CARDS_HAVE: 'البطاقات التي لديها',
        OF: 'من',
        CHOOSE_CARDS: 'اختر البطاقات',
        PLUS: 'أكثر',
        MOINS: 'أقل',
        SAVE: 'حِفْظْ',
        CANCEL: 'إلغاء',
    }
};
